<template>
  <el-input :style="{
    '--color': color,
    '--bg--color': bgColor,
  }" v-model="values" v-bind="$attrs" @blur="$emit('blur')"></el-input>
</template>

<script>

export default {
  components: {},
  props: {
    value: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#333'
    },
    bgColor: {
      type: String,
      default: '#fff'
    }
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {
    values: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  color: var(--color);
  background-color: var(--bg--color);
}

::v-deep .el-textarea__inner {
  color: var(--color);
  background-color: var(--bg--color);
}
</style>

